
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { downloadCsv, yearsList } from 'src/app/core/utils/utils';
import { IFinantialExpensesReport } from 'src/app/shared/interfaces/finantial-expenses-report/ifinantial-expenses-report';
import { IFinantialReceiptsReport } from 'src/app/shared/interfaces/finantial-receipts-report/ifinantial-receipts-report';
import { ModalService } from 'src/app/shared/services/modal.service';
import { finantialExpensesReportActions } from 'src/app/store/finantial-expenses-report/finantial-expenses-report.actions';
import { selectFinantialExpensesReport } from 'src/app/store/finantial-expenses-report/finantial-expenses-report.selectors';
import { SearchExpensesComponent } from '../search-expenses/search-expenses.component';
import { selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';
import { FinantialExpensesReportService } from 'src/app/shared/services/finantial-expenses-report.service';
import { Filter } from 'src/app/shared/models/filter';
import { IFilterData, IFilterModel } from 'src/app/shared/models/filter-model';
import { DateFormat } from 'src/app/core/models/date-format';


@Component({
  selector: 'app-finantial-expenses-report',
  templateUrl: './finantial-expenses-report.component.html',
  styleUrls: ['./finantial-expenses-report.component.scss']
})
export class FinantialExpensesReportComponent {
  expensesYearFilter: any
  expensesUnitFilter: any

  fiveExpensesYearFilter: any
  fiveExpensesUnitFilter: any

  anualExpensesUnitFilter: any

  form!: FormGroup;
  public listData: IFilterData[] = [
    { id: 1, name: new Date() }
  ];
  modalExpensesData = [
    {
      categoria: 'Pagamento médico',
      data: '14/12/2023',
      valor: 'R$ 1.520,12',
      profissional: 'Dra. Layla Lo...',
      conta: 'Cx. Barreiro',
      formaPgto: 'Dinheiro',
      observacoes: 'Consulta pag...'
    },
    {
      categoria: 'Pagamento médico',
      data: '14/12/2023',
      valor: 'R$ 1.520,12',
      profissional: 'Dra. Layla Lo...',
      conta: 'Cx. Barreiro',
      formaPgto: 'Dinheiro',
      observacoes: 'Consulta pag...'
    },
    {
      categoria: 'Pagamento médico',
      data: '14/12/2023',
      valor: 'R$ 1.520,12',
      profissional: 'Dra. Layla Lo...',
      conta: 'Cx. Barreiro',
      formaPgto: 'Dinheiro',
      observacoes: 'Consulta pag...'
    }
  ];
  filterDatas = [
    {
      label: 'Janeiro 2024',
      command: () => {

      }
    },
    {
      label: 'Fevereiro 2024',
      command: () => {

      }
    },
    {
      label: 'Março 2024',
      command: () => {

      }
    }
  ];
  filterYears = this.createFilterYears();
  filterUnits = [
    {
      label: 'Vila Nova',
      command: () => {

      }
    },
    {
      label: 'Barreiro',
      command: () => {

      }
    },
    {
      label: 'Belo Horizonte',
      command: () => {

      }
    }
  ]
  finantialExpensesReports$ = this.store.select(selectFinantialExpensesReport);
  finantialExpensesReportsSubscription$!: Subscription;
  UnitsFilterOptions$ = this.store.select(selectUnitActiveList);

  dataMonthToMonthExpense: any;

  filterExpenses = new Filter();
  filterTopFiveExpenses = new Filter();
  filterAnnualExpenses = new Filter();
  filterReportMonthToMonthExpense = new Filter();
  filterReportExpensesByCategoryMonthByMonth = new Filter();
  currentYear = new Date().getFullYear()
  currentMonth: string = (new Date().getMonth() + 1).toString().padStart(2, '0')
  currentUnit = localStorage.getItem('unitId');


  annualExpensesGraphic: any;
  dataReportTopFiveExpenses: any = {};
  dataReportExpenses: any = {};
  dataCategoryMonthToMonthExpense: any = [];
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalService: ModalService,
    private service: FinantialExpensesReportService
  ) {

  }
  openModalDespesas() {
    this.modalService.calledfor("Search Expenses Dialog");
    this.modalService.show(SearchExpensesComponent, "Pesquisar Despesa", this.modalExpensesData);
  }
  createFilterYears(): any {
    return yearsList().map(year => {
      return {
        label: year.toString(),
        command: () => { }
      }
    });
  }
  ngOnInit(): void {
    this.loadExpensesGraphic()
    this.loadAnnualExpensesGraphic()

    let date = new Date()
    this.listData[0] = { id: 1, name: date };
    this.filterTopFiveExpenses
      .filter("month", date.getMonth() + 1, "AND")
      .filter("year", date.getFullYear(), "AND");
    this.loadTopFiveExpensesGraphic()

    this.filterReportMonthToMonthExpense
      .filter("unit", this.currentUnit as string, "IN")
      .filter("year", 2024, "AND")
    this.loadReportMonthToMonthExpense();

    this.filterReportExpensesByCategoryMonthByMonth
      .filter("unit", this.currentUnit as string, "IN")
      .filter("year", 2024, "AND")
    this.loadReportExpensesByCategoryMonthByMonth();
    //this.store.dispatch(finantialExpensesReportActions.loadFinantialExpensesReport());

    /*this.finantialExpensesReportsSubscription$ = this.finantialExpensesReports$.subscribe({
      next: (res: IFinantialExpensesReport) => {
       
        if (res != null || undefined) {
    
          let gradientColors = ['#6D6CCD', 'rgba(255, 255, 255, 0)'];
          let gradientColorsAtendimento = ['#004AA0', 'rgba(255, 255, 255, 0)'];
          let gradientColorsProcedimento = ['#00A000', 'rgba(255, 255, 255, 0)'];
          let gradientColorsExame = ['#DB0000', 'rgba(255, 255, 255, 0)'];
          let gradientColorsOutros = ['#FF8321', 'rgba(255, 255, 255, 0)'];

      
          this.form.patchValue({
            economia_mes_a_mes_data: [this.createDataSet(res.economia_mes_a_mes,gradientColors)],
            economia_mes_a_mes_label: res.economia_mes_a_mes.map(obj => obj.label),
            tipos_receita_mes_a_mes_data: [
              this.createDataSet(res.atendimento_mes_a_mes,gradientColorsAtendimento,'Atendimentos'),
              this.createDataSet(res.procedimento_mes_a_mes,gradientColorsProcedimento,'Procedimentos'),
              this.createDataSet(res.exame_mes_a_mes,gradientColorsExame,'Exames'),
              this.createDataSet(res.outro_mes_a_mes,gradientColorsOutros,'Outros')
            ],
            tipos_receita_mes_a_mes_label: res.atendimento_mes_a_mes.map(obj => obj.label),
            top_5_gastos_label: res.top_5_gastos.map(obj => obj.label),
            top_5_gastos_data: res.top_5_gastos.map(obj => obj.data)
          })

        }
      }
    });*/
  }
  createDataSet(data: Array<{ data: any, label: any }>, gradientColors: Array<string>, legend?: string) {
    let dataSet = data.map(obj => obj.data);
    return { data: dataSet, gradientColors, legend }
  }
  ngOnDestroy() {
  }

  createReceitaAnualMock() {
    return [
      { valor: '148.000', descricao: 'Despesas' }
    ]
  }
  createReceitaMesAMesMock() {
    let columns = [
      {
        valor: 48.000,
        descricao: 'Despesas'
      }

    ];
    let columnsNegativo = [
      {
        valor: 48.000,
        descricao: 'Despesas'
      }
    ];
    return [
      {
        data: '23/12/2023',
        columns
      },
      {
        data: '23/11/2023',
        columns
      },
      {
        data: '23/10/2023',
        columns
      },
      {
        data: '23/09/2023',
        columns
      },
      {
        data: '23/08/2023',
        columns: columnsNegativo
      },
      {
        data: '23/07/2023',
        columns
      },
      {
        data: '23/06/2023',
        columns
      },
      {
        data: '23/05/2023',
        columns: columnsNegativo
      },
      {
        data: '23/04/2023',
        columns: columnsNegativo
      },
      {
        data: '23/03/2023',
        columns
      },
      {
        data: '23/02/2023',
        columns
      },
      {
        data: '23/01/2023',
        columns
      }

    ]
  }

  setExpensesYearFilter(event: any) {
    let date = new Date(event)
    console.log("year: ", date.getFullYear())
  }

  resetExpensesYearFilter() {
    this.expensesYearFilter = null
  }

  addExpensesUnitFilter() {
    console.log('unit: ', this.expensesUnitFilter)
  }


  setFiveExpensesYearFilter(event: any) {
    let date = new Date(event)
    console.log("year: ", date.getFullYear())
  }

  resetFiveExpensesYearFilter() {
    this.fiveExpensesYearFilter = null
  }

  addFiveExpensesUnitFilter() {
    console.log('unit: ', this.fiveExpensesUnitFilter)
  }


  addAnualExpensesUnitFilter() {
    console.log('unit: ', this.anualExpensesUnitFilter)
  }

  loadExpensesGraphic(filter: string = '') {

    let gradientColors = ['#6D6CCD', 'rgba(255, 255, 255, 0)'];

    if (filter == '') {
      filter = `?unit[]=${this.currentUnit}&year=${this.currentYear}`
    }

    if (filter.includes('unit') == false) {
      filter = filter + `&unit[]=${this.currentUnit}`
    }

    if (filter.includes('year') == false) {
      filter = filter + `&year=${this.currentYear}`
    }

    this.service.getExpenses(filter).subscribe((res: any) => {
      this.dataReportExpenses = res;
      this.dataReportExpenses.labels = Object.keys(res.graphic);
      this.dataReportExpenses.data = [{
        gradientColors: gradientColors,
        data: Object.values(res.graphic),
        legend: 'Despesas'
      }];
      console.log(this.dataReportExpenses)
      /*this.form.patchValue({
        expenseActual: res.expenseActual,
        expensePrevious: res.expensePrevious,
        expensesGraphic:{ 
          labels: Object.keys(res.lastSevenMonths),
          data: [{
            data: Object.values(res.lastSevenMonths),
            gradientColors: gradientColors 
          }]
        }
      })*/
    })
  }

  loadTopFiveExpensesGraphic() {

    let filters = this.filterTopFiveExpenses.convertFilterInQuery()

    if (filters.includes('unit') == false) {
      filters += `&unit[]=${this.currentUnit}`
    }

    this.service.getTopFiveExpenses(filters).subscribe((res: any) => {
      this.dataReportTopFiveExpenses.data = Object.values(res.graphic);
      this.dataReportTopFiveExpenses.labels = Object.keys(res.graphic);
      /*this.form.patchValue({
        topFiveExpenses: {
          data: res.map((list: any) => list.expense),
          labels: res.map((list: any) => list.category)
        }
      })*/
    })
  }

  loadAnnualExpensesGraphic(filters: string = '') {

    if (filters == '') {
      filters = `?unit[]=${this.currentUnit}`
    }

    this.service.getLastThreeMonths(filters).subscribe(
      (response: any) => {
        this.annualExpensesGraphic = Object.keys(response.graphic).map((key) => { return { ano: key, value: response.graphic[key] } });
      }
    )
  }

  onFilterExpenses(event: IFilterModel[]) {
    event.forEach(e => {
      this.filterExpenses.setFilter(e.key, e.filter);
    });

    this.loadExpensesGraphic(this.filterExpenses.convertFilterInQuery())

  }

  onFilterFiveExpenses(event: IFilterModel[]) {
    /* acertar filtro por mes */
    event.forEach(e => {
      if (e.key == "month") {
        if (e.filter.length > 0) {
          let [day, month, year] = DateFormat.splitDate(e.filter[0].value as Date);
          this.filterTopFiveExpenses.filter("month", month as any, "AND");
          this.filterTopFiveExpenses.filter("year", year as any, "AND");
        }
      } else
        this.filterTopFiveExpenses.setFilter(e.key, e.filter);
    });

    this.loadTopFiveExpensesGraphic()

  }

  onFilterAnnualExpenses(event: IFilterModel[]) {
    event.forEach(e => {
      this.filterAnnualExpenses.setFilter(e.key, e.filter);
    });

    this.loadAnnualExpensesGraphic(this.filterAnnualExpenses.convertFilterInQuery())

  }

  loadReportMonthToMonthExpense() {
    let filter = this.filterReportMonthToMonthExpense.convertFilterInQuery();


    this.service.getReportMonthToMonthExpense(filter).subscribe((response: any) => {
      this.dataMonthToMonthExpense = [];
      Object.keys(response).forEach((item: any) => {
        let columns = [];
        columns.push({
          valor: response[item]['expense'],
          descricao: 'Despesas Total'
        });
        columns.push({
          valor: response[item]['split'],
          descricao: 'Repasse Split'
        });

        this.dataMonthToMonthExpense.push({
          percentage: 0,
          data: item,
          columns: columns
        });
      })
    })
  }

  loadReportExpensesByCategoryMonthByMonth() {
    let filter = this.filterReportExpensesByCategoryMonthByMonth.convertFilterInQuery();
    this.service.getReportExpensesByCategoryMonthByMonth(filter).subscribe((response: any) => {
      this.dataCategoryMonthToMonthExpense = [];
      Object.keys(response).forEach((item: any) => {
        let columns: any = [];
        if (response[item] != null) {
          Object.keys(response[item]).forEach((element: any) => {
            columns.push({
              valor: response[item][element],
              descricao: element
            });
          })
        }
        /*columns.push({
          valor: response[item]['expense'],
          descricao: 'Despesas Total'
        });
        columns.push({
          valor: response[item]['split'],
          descricao: 'Repasse Split'
        });*/

        this.dataCategoryMonthToMonthExpense.push({
          percentage: 0,
          data: item,
          columns: columns
        });

        console.log(this.dataCategoryMonthToMonthExpense);
      })
    })
  }

  downloadAnnualExpenses() {
    let filter = this.filterAnnualExpenses.convertFilterInQuery()

    if (filter == '') {
      filter = `?unit[]=${this.currentUnit}`
    }

    filter = filter + '&csv=true'

    this.service.getLastThreeMonths(filter).subscribe(csv => {
      downloadCsv("data:text/csv;charset=utf-8," + csv, 'annual_expense');
    })
  }
}
